import { CommonModalConfig } from '@/api/resources/common/shared/models/common.models'
import { ShipmentItemResponse, ShipmentRequestResponse } from '@/modules/shipments-module/services/shipments.dto'
import { initialCrudModelBaseState, CrudModelBase } from '@/shared/models/cruds.models'
import { CommonLaboratoryDatasource } from '@/shared/resources/datasources/common/common-laboratory-datasource'
import i18n from '@/lang/i18n'

const shipmentsGridModalConfig: CommonModalConfig = {
    name: 'cancelShipmentModal',
    storeName: 'shipmentModalState',
    checkable: i18n.tc('component.modalConfirmation.dontShowAgain'),
    content: i18n.tc('shipments.actions.cancelWarningText'),
    uiComponent: 'uicomponent.shipments.modalconfig'
}

export type ShipmentsGridReturningTypes = ShipmentRequestResponse | ShipmentItemResponse

export interface ShipmentsGridState<R = ShipmentsGridReturningTypes> extends CrudModelBase<R, CommonLaboratoryDatasource<R>> {
    modalConfig: CommonModalConfig
}
export const initialShipmentsGridState =
    (): ShipmentsGridState => ({
        ...initialCrudModelBaseState(),
        modalConfig: shipmentsGridModalConfig
    })
